export default __webpack_public_path__ + "static/media/howItWorksBox.3fa4a595.svg";